import Vue from 'vue';

const VueSizeTracker = {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          VueSizeTracker: {
            size: {},
            modal: {
              modal_mode: false,
            },
          },
        };
      },
      computed: {
        screenSize() {
          window.addEventListener('load', this.getScreenSizeVST());
          window.addEventListener('resize', this.getScreenSizeVST);
          return this.VueSizeTracker.size;
        },
        isDesktop() {
          return this.screenSize.width > 768;
        },
        isMobile() {
          return this.screenSize.width <= 768;
        },
      },
      methods: {
        initSizes() {
          this.getScreenSizeVST();
        },

        getScreenSizeVST() {
          const w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0];

          this.VueSizeTracker.size = {
            width: w.innerWidth || e.clientWidth || g.clientWidth,
            height: w.innerHeight || e.clientHeight || g.clientHeight,
          };
        },
      },
    });
  },
};

export default function() {
  Vue.use(VueSizeTracker);
}
